import { Component, OnInit, HostListener, ViewChild, ViewChildren, QueryList, Input } from '@angular/core';
import { WpapiService } from 'src/app/services/wpapi.service';
import { Work } from 'src/app/interfaces/work.interface';
import { fadeAnimation, workAnimation } from 'src/app/animations/animation';
import { PageService } from 'src/app/services/page.service';
import { Subject } from "rxjs";
import { throttleTime } from 'rxjs/operators';
import { SearchService } from 'src/app/services/search.service';
import { SeoService } from 'src/app/services/seo.service';

export enum KEY_CODE {
    UP_ARROW = 38,
    DOWN_ARROW = 40
}

@Component({
    selector: 'app-works',
    templateUrl: './works.component.html',
    styleUrls: ['./works.component.scss'],
    animations: [workAnimation, fadeAnimation]
})
export class WorksComponent implements OnInit {
    response: Work[] = [];
    results: Work[] = [];
    works: any;
    demoWorkPosts: Work[] = [];
    finalWorkPosts: Work[] = [];
    stopScrollAnimation: boolean = false;
    categories: any;
    counter = 0;
    pageCounterValue = 0;
    pageCounter = 0;
    screenHeight;
    scrollHeight;
    checkTextDone;
    isMac = navigator.platform;
    isOld = navigator.userAgent;
    is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    elemWidth: number;
    elemHeight: number;
    elemLeft: number;
    screenWidth: number;
    elementTop: number = 0;
    elemTop: number;
    elemTopBack: number;
    elemRight: number;
    elemBottom: number;
    elemBottomBack: number;
    elemLeftBack: number;
    elemRightBack: number;
    elemWidthBack: number;
    elemHeightBack: number;
    screenTop: number;
    state = 'closed';
    activeItem: number;
    menuActive = false;
    activeGrid = false;
    quickViewActive = false;
    pausescroll: boolean = false;
    transform: number = 0;
    pageNumber: number = 0;
    setActiveFilter: string = 'all';
    counterposition: number = 0;
    titleFont: number = 0;
    subTitleFont: number = 0;
    fullTitleFont: number = 0;
    fullSubTitleFont: number = 0;
    titleLineH: number = 0;
    subTitleLineH: number = 0;
    fullTitleLineH: number = 0;
    fullSubTitleLineH: number = 0;
    wrapperTop: number = 0;
    wrapperTopFull: number = 0;
    active = false;
    currentY;
    initialY;
    touchdirection: number = 0;
    touchstart: number = 0;
    bottomStop: boolean = true;
    topStop: boolean = false;
    swiped: boolean = false;
    direction: string = '';
    noResults: boolean = false;
    noResultsFade: boolean = false;
    activateMenuOverlay: boolean = false;
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    length: number = 5;
    private SubjectUp = new Subject<number>();
    private SubjectDown = new Subject<number>();
    private SubjectUpMac = new Subject<number>();
    private SubjectDownMac = new Subject<number>();
    @ViewChildren('workitems') workitems: QueryList<any>;

    constructor(private wpApi: WpapiService,
        private searchService: SearchService,
        private pageService: PageService,
        private seoService: SeoService
    ) {

        this.screenWidth = window.innerWidth;
        if (this.screenWidth > 1024) {
            this.screenHeight = document.getElementById('main-container-wrapper').clientHeight - 10;
        } else {
            this.screenHeight = Math.ceil((document.getElementById('main-container-wrapper').clientHeight + 5) * 0.99);
        }
        this.pageService.listen().subscribe((m: boolean) => {
            this.onMenuActive(m);
        })
        this.pageService.returnInitAnimation().subscribe(() => {
            this.zoomAfterSinglePostsActive();
        })
        this.pageService.returnCategory().subscribe((resp) => {
            this.handleCategoriesResponse(resp);
        });
        this.searchService.listen().subscribe((resp) => {
            this.handleSearchResponse(resp);
        })
        this.pageService.goToTopListen().subscribe(() => {
            if (this.isIPadPro && this.screenWidth > 1024) {
                const grid = document.getElementById('main-container-wrapper');
                grid.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                this.counter = 0;
            }
        })
        this.pageService.removeSearchListen().subscribe(() => {
            this.removeNoResult();
        })
    }

    onMenuActive(m) {
        this.menuActive = m;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.counter = 0;
        this.screenWidth = window.innerWidth;
        if (this.screenWidth > 1024) {
            this.screenHeight = document.getElementById('main-container-wrapper').clientHeight - 10;
            this.pageCounter = Math.ceil(this.pageCounterValue / 8);
        } else {
            this.screenHeight = Math.ceil((document.getElementById('main-container-wrapper').clientHeight + 5) * 0.99);
            this.pageCounter = Math.ceil(this.response.length / 3);
        }
        this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
        if (this.counter < -(this.scrollHeight - this.screenHeight)) {
            this.counter = -(this.scrollHeight - this.screenHeight);
        } else {
            this.counter = -(Math.floor(-(this.counterposition) / this.screenHeight)) * this.screenHeight;
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode === KEY_CODE.UP_ARROW) {
            this.onScrollUp();
        }

        if (event.keyCode === KEY_CODE.DOWN_ARROW) {
            this.onScrollDown();
        }
    }

    ngOnInit() {
        this.onResize();
        this.state = (this.state === 'closed' ? 'opened' : 'closed');

        var url = window.location.href;
        var query_string_paramter = url.split("?")[1];
        if (query_string_paramter) {
            var parameter_category = query_string_paramter.replace('category=', '');
            if (parameter_category) {
                this.wpApi.getCatgories().subscribe(resp => {
                    this.handleFilteredInitPosts(resp, parameter_category);
                })
            }
            var parameter_search = query_string_paramter.replace('search=', '').replace('%20', ' ');
            if (parameter_search) {
                this.getCategories();
                this.handleCategoriesOnInit(parameter_search);
            }
        } else {
            this.getWorks();
            this.getCategories();
        }
        this.SubjectUp.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventUp(x));

        this.SubjectDown.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventDown(x));

        this.SubjectUpMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventUpMac(x));

        this.SubjectDownMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventDownMac(x));
        this.checkTextDone = '';
        this.pageService.showGoToTopButton(false);
        this.getWorksPage();
    }

    getWorksPage() {
        this.wpApi.getWorksPage().subscribe(resp => {
            this.seoService.setSeoMetaTags(resp[0]);
        });
    }

    ngAfterViewInit() {
        this.workitems.changes.subscribe(t => {
            this.zoomRecall();
        })
    }

    getCategories() {
        this.wpApi.getCatgories().subscribe(resp => {
            this.categories = resp;
        })
    }

    handleCategoriesOnInit(params) {
        this.wpApi.getWorks().subscribe(resp => {
            this.works = resp;
            this.handleSearchResponse(params);
        })
    }

    handleSearchResponse(resp) {
        this.response = [];
        this.finalWorkPosts = [];
        this.pageCounterValue = 0;
        this.pageCounter = 0;
        this.scrollHeight = 0;
        const data = this.works;
        for (let i = 0; i < data.length; i++) {
            if (data[i].title.rendered.toLowerCase().includes(resp.toLowerCase()) ||
                data[i].acf.subtitle.toLowerCase().includes(resp.toLowerCase()) ||
                this.checkIfCategory(data[i], resp) ||
                this.checkIfTag(data[i], resp)) {
                this.pageCounterValue += parseInt(data[i].acf.madhesia);
                this.response.push({
                    id: data[i].id,
                    post_size: parseInt(data[i].acf.madhesia),
                    slug: data[i].slug,
                });
            }
        };
        var category = resp.split("=")[0];
        if (this.response.length == 0) {
            if (category != "category") {
                this.noResults = true;
                setTimeout(() => {
                    this.noResultsFade = true;
                }, 100);
            }
        } else {
            this.noResultsFade = false;
            setTimeout(() => {
                this.noResults = false;
            }, 100);
        }
        if (this.screenWidth > 1024) {
            this.pageCounter = Math.ceil(this.pageCounterValue / 8);
            if (this.response.length == 0) {
                this.scrollHeight = this.screenHeight * 2;
            } else {
                this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
            }
        } else {
            this.pageCounter = Math.ceil(this.response.length / 3);
            this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
        }
        for (let i = 0; i < this.pageCounter; i++) {
            this.responseHandler();
        }
    }

    checkIfCategory(data, resp) {
        for (let index = 0; index < this.categories?.length; index++) {
            const category = this.categories[index];
            if (category.name.toLowerCase().includes(resp.toLowerCase())) {
                if (data.work_categories.includes(category.id)) {
                    return true;
                }
            }
        }
    }

    checkIfTag(data, resp) {
        if (data.acf.tags) {
            const tags = data.acf.tags.split(',');
            for (let index = 0; index < tags.length; index++) {
                const tag = tags[index];
                if (tag.toLowerCase().includes(resp.toLowerCase())) {
                    return true;
                }
            }
        } else {
            return false;
        }
    }

    handleCategoriesResponse(resp) {
        this.getPostByCategory(resp.id, resp.slug)
    }

    handleFilteredInitPosts(resp, parameter) {
        const data = resp;
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.slug == parameter) {
                this.getPostFiteredOnInit(element.id, element.slug);
            }
        }
    }

    getPostFiteredOnInit(id, slug) {
        this.wpApi.getWorks().subscribe(resp => {
            this.works = resp;
            this.handleWorks(resp);
            this.getPostByCategory(id, slug)
        });
    }

    getPostByCategory(category, slug) {
        if (this.setActiveFilter !== slug) {
            this.setActiveFilter = slug
            this.response = [];
            this.finalWorkPosts = [];
            this.pageCounterValue = 0;
            this.pageCounter = 0;
            this.scrollHeight = 0;
            setTimeout(() => {
                const data = this.works;
                if (slug === 'all') {
                    for (let i = 0; i < data.length; i++) {
                        this.pageCounterValue += parseInt(data[i].acf.madhesia);
                        this.response.push({
                            id: data[i].id,
                            slug: data[i].slug,
                            post_size: parseInt(data[i].acf.madhesia),
                        });
                    };
                } else {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].work_categories.includes(category)) {
                            this.pageCounterValue += parseInt(data[i].acf.madhesia);
                            this.response.push({
                                id: data[i].id,
                                slug: data[i].slug,
                                post_size: parseInt(data[i].acf.madhesia),
                            });
                        }
                    };
                }
                if (this.screenWidth > 1024) {
                    this.pageCounter = Math.ceil(this.pageCounterValue / 8);
                    this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
                } else {
                    this.pageCounter = Math.ceil(this.response.length / 3);
                    this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
                }
                // this.stopScrollAnimation = true;
                setTimeout(() => {
                    this.counter = 0;
                }, 100);
                // setTimeout(() => {
                //    this.stopScrollAnimation = false;    
                // }, 400);
                for (let i = 0; i < this.pageCounter; i++) {
                    this.responseHandler();
                }
            }, 400);
            if (this.screenWidth <= 1024) {
                setTimeout(() => {
                    const element = document.querySelector('#grid-items-wrapper');
                    element.scrollIntoView();
                }, 600);
            }
        }
    }

    getWorks() {
        this.wpApi.getWorks().subscribe(resp => {
            this.works = resp;
            this.handleWorks(resp);
        });
    }

    handleWorks(resp) {
        for (let i = 0; i < resp.length; i++) {
            this.pageCounterValue += parseInt(resp[i].acf.madhesia);
            this.response.push({
                id: resp[i].id,
                post_size: parseInt(resp[i].acf.madhesia),
                slug: resp[i].slug,
            });
        };
        if (this.screenWidth > 1024) {
            this.pageCounter = Math.ceil(this.pageCounterValue / 8);
            this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight;
        } else {
            this.pageCounter = Math.ceil(this.response.length / 3);
            this.scrollHeight = (this.pageCounter * this.screenHeight) + this.screenHeight
        }
        for (let i = 0; i < this.pageCounter; i++) {
            this.responseHandler();
        }
    }

    responseHandler() {
        let total = 0;
        let globalArr = [];
        let globalArrFiltered = [];
        total = 0;
        let increment = [];
        if (this.pageNumber < this.pageCounter) {
            this.pageNumber = this.pageNumber + 1;
        }
        for (let i = 0; i < this.response.length; i++) {
            total = this.response[i].post_size + total;
            if (total <= 8) {
                this.results.push({
                    id: this.response[i].id,
                    post_size: this.response[i].post_size,
                    slug: this.response[i].slug,
                });
                increment[i] = this.response[i];
            } else {
                total = total - this.response[i].post_size;
            }
            if (this.response.length == (i + 1) && total < 8) {
                globalArr[i] = increment.filter(function (el) {
                    return el != null;
                });
            }
        }
        this.response = this.response.filter((elem) => !this.results.find(({ id }) => elem.id === id));
        globalArrFiltered = globalArr.filter(function (el) {
            return el != null;
        });
        for (let z = 0; z < globalArrFiltered.length; z++) {
            let lowest = Number.POSITIVE_INFINITY;
            let tmp;
            let totalValue = 0;
            let idValue = 0;
            for (let n = globalArrFiltered[z].length - 1; n >= 0; n--) {
                tmp = globalArrFiltered[z][n].post_size;
                totalValue += globalArrFiltered[z][n].post_size;
                if (tmp < lowest) {
                    lowest = tmp;
                    idValue = globalArrFiltered[z][n].id;
                }
            }
            let subtotal = 0;
            for (let l = 0; l < this.results.length; l++) {
                if (this.results[l].id == idValue) {
                    this.results[l].post_size = this.results[l].post_size + (8 - totalValue);
                    if (this.results[l].post_size == 3 || this.results[l].post_size == 5 || this.results[l].post_size == 7 || this.results[l].post_size == 9) {
                        this.results[l].post_size = this.results[l].post_size - 1;
                    }
                }
                subtotal += this.results[l].post_size;
            }
            if (subtotal % 8 != 0) {
                let secondsubtotal = 0;
                for (let s = 0; s < this.results.length; s++) {
                    if (this.results[s].id == idValue) {
                        if (this.results[s + 1] != null) {
                            this.results[s + 1].post_size = this.results[s + 1].post_size + 1;
                            if (this.results[s + 1].post_size == 3 || this.results[s + 1].post_size == 5 || this.results[s + 1].post_size == 7 || this.results[s + 1].post_size == 9) {
                                this.results[s + 1].post_size = this.results[s + 1].post_size - 1;
                            }
                        }
                        secondsubtotal += this.results[s].post_size;
                    }
                }
                if (secondsubtotal % 8 != 0) {
                    for (let t = 0; t < this.results.length; t++) {
                        if (this.results[t].id == idValue) {
                            this.results[t - 1].post_size = this.results[t - 1].post_size + 1;
                            if (this.results[t - 1].post_size == 3 || this.results[t - 1].post_size == 5 || this.results[t - 1].post_size == 7 || this.results[t - 1].post_size == 9) {
                                this.results[t - 1].post_size = this.results[t - 1].post_size - 1;
                                this.results[t - 2].post_size = this.results[t - 2].post_size + 1;
                            }
                        }
                    }
                }
            }
        }
        for (let m = 0; m < this.results.length; m++) {
            if (this.results[m]?.post_size == 6) {
                if (this.results[m - 1]?.post_size == 1) {
                    this.results[m].post_size = 4;
                    this.results[m - 1].post_size = 2;
                    this.results[m - 2].post_size = 2;
                } else if (this.results[m - 1]?.post_size == 2) {
                    this.results[m].post_size = 4;
                    this.results[m - 1].post_size = 4;
                } else if (this.results[m + 1]?.post_size == 2) {
                    this.results[m].post_size = 4;
                    this.results[m + 1].post_size = 4;
                }
            }
        }
        function move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                let k = new_index - arr.length;
                while ((k--) + 1) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }
        let demoPostsTotal = 0;
        for (let p = 0; p < this.results.length; p++) {
            demoPostsTotal += this.results[p].post_size;
            if (demoPostsTotal <= 8) {
                this.demoWorkPosts.push(this.results[p]);
            }
            if (demoPostsTotal == 8) {
                for (let a = 0; a < this.demoWorkPosts.length; a++) {
                    if (this.demoWorkPosts.length == 3 && this.demoWorkPosts[a].post_size == 4) {
                        if (this.demoWorkPosts[a - 1] && this.demoWorkPosts[a - 2]) {
                            if (this.demoWorkPosts[a - 1].post_size == 2 && this.demoWorkPosts[a - 2].post_size == 2) {
                                move(this.demoWorkPosts, a, a - 1);
                            }
                        }
                    } else if (this.demoWorkPosts.length == 4 && this.demoWorkPosts[a].post_size == 4) {
                        move(this.demoWorkPosts, a, 0);
                    } else if (this.demoWorkPosts.length == 5 && this.demoWorkPosts[a].post_size == 4) {
                        move(this.demoWorkPosts, a, 0);
                    }
                }
                for (let b = 0; b < this.demoWorkPosts.length; b++) {
                    this.finalWorkPosts.push(this.demoWorkPosts[b]);
                }
                demoPostsTotal = 0;
                this.demoWorkPosts = [];
                this.results = [];
            }
        }
    }

    mouseWheelUpFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUpMac.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUpMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUp.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUp.next(event);
                    }
                }
            }
        }
    }

    mouseWheelDownFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDownMac.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDownMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDown.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDown.next(event);
                    }
                }
            }
        }
    }

    private doSomethingWithThrottledEventUp(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventUpMac(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventDown(event: any) { this.onScrollDown(); }
    private doSomethingWithThrottledEventDownMac(event: any) { this.onScrollDown(); }

    onScrollUp() {
        if (this.pausescroll == false) {
            if (this.counter < 0) {
                this.counter += (this.screenHeight);
                this.pageService.rotateLeftLogo();
            }
            if (this.counter > 0) {
                this.counter = 0;
                this.pageService.rotateLeftLogo();
            }
            this.counterposition = this.counter;
        }
    }

    onScrollDown() {
        if (this.pausescroll == false) {
            this.counter -= (this.screenHeight);
            if (this.counter < -(this.scrollHeight - this.screenHeight)) {
                this.counter = -(this.scrollHeight - this.screenHeight);
            } else {
                this.pageService.rotateRightLogo();
            }
            this.counterposition = this.counter;
        }
    }

    public handleAnimation(resp: any): void {
        this.activeItem = resp.active;
        this.elemWidth = resp.width - 10;
        this.elemHeight = resp.height - 10;
        this.elemLeft = resp.left + 5;
        this.elemRight = resp.right + 5;
        this.elemTop = resp.top + 5;
        this.elemBottom = resp.bottom + 5;
        if (!this.is_safari) {
            this.elemRightBack = this.elemRight + 5;
            this.elemLeftBack = this.elemLeft + 5;
            this.elemWidthBack = this.elemWidth - 10;
            this.elemHeightBack = this.elemHeight - 10;
            this.elemBottomBack = this.elemBottom + 5;
            this.elemTopBack = this.elemTop + 5;
        } else {
            this.elemRightBack = resp.right;
            this.elemLeftBack = resp.left;
            this.elemWidthBack = this.elemWidth - 5;
            this.elemHeightBack = this.elemHeight - 5;
            this.elemTopBack = this.elemTop + 5;
            this.elemBottomBack = this.elemBottom;
        }
        this.screenTop = -(this.counter);

        this.wrapperTop = this.elemHeight / 2 - 20;
        this.wrapperTopFull = this.screenHeight / 2 - 55;
        this.pageService.getWorkInit('workinit');
        this.state = (this.state === 'closed' ? 'opened' : 'closed');
    }

    public handleResetAnimation(resp: any): void {
        this.elemWidth = resp.width - 10;
        this.elemHeight = resp.height - 10;
        this.elemLeft = resp.left + 5;
        this.elemRight = resp.right + 5;
        this.elemTop = resp.top + 5;
        this.elemBottom = resp.bottom + 5;
        if (!this.is_safari) {
            this.elemRightBack = this.elemRight + 5;
            this.elemLeftBack = this.elemLeft + 5;
            this.elemWidthBack = this.elemWidth - 10;
            this.elemHeightBack = this.elemHeight - 10;
            this.elemBottomBack = this.elemBottom + 5;
            this.elemTopBack = this.elemTop + 5;
        } else {
            this.elemRightBack = resp.right;
            this.elemLeftBack = resp.left;
            this.elemWidthBack = this.elemWidth - 5;
            this.elemHeightBack = this.elemHeight - 5;
            this.elemTopBack = this.elemTop + 5;
            this.elemBottomBack = this.elemBottom;
        }
        this.wrapperTop = this.elemHeight / 2 - 20;
        this.wrapperTopFull = this.screenHeight / 2 - 55;
    }

    reactivate(event) {
        let workactive = <any>document.querySelector('.post-active .post-active-wrapper');
        let heading3 = <any>document.querySelector('.post-active .post-content-wrapper h3');
        let heading5 = <any>document.querySelector('.post-active .post-content-wrapper h5');
        let wrapper = <any>document.querySelector('.post-active .post-content-wrapper');
        if (workactive) {
            if (event.fromState == 'closed' && event.toState == 'opened') {
                workactive.style.width = (this.screenWidth) + 'px';
                workactive.style.height = (this.screenHeight + 10) + 'px';
                workactive.style.top = -(this.counter) + 'px';
                workactive.style.left = '-10px';
                workactive.style.right = '-10px';
                workactive.style.bottom = '-10px';
                workactive.style.zIndex = '999';

                heading3.classList.remove('animate');
                heading5.classList.remove('animate');

                wrapper.style.left = '80px';
                wrapper.style.top = (this.wrapperTopFull - 7) + 'px';
                workactive.classList.add('position-fixed');
            } else {
                workactive.style.width = '';
                workactive.style.height = '';
                workactive.style.top = '';
                workactive.style.bottom = '';
                workactive.style.left = '';
                workactive.style.right = '';
                workactive.style.zIndex = '';

                heading3.classList.add('animate');
                heading5.classList.add('animate');

                wrapper.style.left = '';
                wrapper.style.bottom = '';
                wrapper.style.top = '';
                wrapper.disabled = true;
                workactive.classList.remove('position-fixed');
                if (this.is_safari) {
                    workactive.style.display = 'none';
                    setTimeout(() => {
                        workactive.style.display = 'block';
                    }, 3);
                }
            }
        }
    }

    zoomRecall() {
        if (window.location.pathname.includes('/works/')) {
            const url = window.location.pathname.replace('/works/', '');
            const element = document.getElementById('post-item-' + url);
            const index = element.getAttribute('data-index');
            setTimeout(() => {
                this.activeItem = parseFloat(index);
            }, 0);
            setTimeout(() => {
                let workactive = <any>document.querySelector('.post-active .post-active-wrapper');
                this.elemWidth = workactive.offsetWidth + 10;
                this.elemHeight = workactive.offsetHeight + 10;
                this.elemLeft = workactive.offsetParent.offsetParent.offsetLeft + 5;
                this.elemRight = (this.elemWidth + workactive.offsetParent.offsetParent.offsetLeft) + 5;
                this.elemTop = workactive.offsetParent.offsetParent.offsetTop + 5;
                this.elemBottom = (this.elemTop + workactive.offsetHeight) + 5;
                this.elemRightBack = this.elemRight + 5;
                this.elemLeftBack = this.elemLeft + 5;
                this.elemWidthBack = this.elemWidth - 10;
                this.elemHeightBack = this.elemHeight - 10;
                this.elemBottomBack = this.elemBottom + 5;
                this.elemTopBack = this.elemTop + 5;
                this.counter = -Math.floor(workactive.offsetParent.offsetParent.offsetTop / this.screenHeight) * this.screenHeight;
                this.wrapperTop = this.elemHeight / 2 - 20;
                this.wrapperTopFull = this.screenHeight / 2 - 55;
                this.titleFont = 32;
                this.titleLineH = 44;
                this.fullTitleFont = 72;
                this.fullTitleLineH = 80;
                this.subTitleFont = 18;
                this.subTitleLineH = 18;
                this.fullSubTitleFont = 32;
                this.fullSubTitleLineH = 44;
                this.screenTop = -(this.counter);
            }, 100);
            this.pageService.worksLoaded();
        }
    }

    zoomAfterSinglePostsActive() {
        this.checkIfElementActive();
        if (window.location.pathname.includes('/works/')) {
            const url = window.location.pathname.replace('/works/', '');
            const element = document.getElementById('post-item-' + url);
            const index = element.getAttribute('data-index');
            setTimeout(() => {
                this.activeItem = parseFloat(index);
            }, 0);
            setTimeout(() => {
                let workactive = <any>document.querySelector('.post-active .post-active-wrapper');
                this.elemWidth = workactive.offsetWidth + 10;
                this.elemHeight = workactive.offsetHeight + 10;
                this.elemLeft = workactive.offsetParent.offsetLeft + 5;
                this.elemRight = (this.elemWidth + workactive.offsetParent.offsetLeft) + 5;
                this.elemTop = workactive.offsetParent.offsetTop + 5;
                this.elemBottom = (this.elemTop + workactive.offsetHeight);
                this.elemRightBack = this.elemRight + 5;
                this.elemLeftBack = this.elemLeft + 5;
                this.elemWidthBack = this.elemWidth - 10;
                this.elemHeightBack = this.elemHeight - 10;
                this.elemBottomBack = this.elemBottom + 5;
                this.elemTopBack = this.elemTop + 5;
                this.counter = -Math.floor(workactive.offsetParent.offsetTop / this.screenHeight) * this.screenHeight;
                this.wrapperTop = this.elemHeight / 2 - 20;
                this.wrapperTopFull = this.screenHeight / 2 - 55;
                this.titleFont = 32;
                this.titleLineH = 38;
                this.fullTitleFont = 72;
                this.fullTitleLineH = 80;
                this.subTitleFont = 18;
                this.subTitleLineH = 18;
                this.fullSubTitleFont = 32;
                this.fullSubTitleLineH = 44;
                this.screenTop = -(this.counter);
            }, 100);
        }
    }

    checkIfElementActive() {
        let workactive = <any>document.querySelector('.post-active .post-active-wrapper');
        if (workactive) {
            let heading3 = <any>document.querySelector('.post-active .post-title');
            let heading5 = <any>document.querySelector('.post-active .post-client');
            let wrapper = <any>document.querySelector('.post-active .post-content-wrapper');

            workactive.style.position = '';
            workactive.style.width = '';
            workactive.style.height = '';
            workactive.style.top = '';
            workactive.style.bottom = '';
            workactive.style.left = '';
            workactive.style.right = '';
            workactive.style.zIndex = '';

            heading3.classList.add('animate');
            heading5.classList.add('animate');

            wrapper.style.left = '';
            wrapper.style.top = '';
            workactive.classList.remove('position-fixed');
        }
    }

    handleScrollPause(event) {
        if (event === 'pause') {
            this.pauseScrollEvent();
        } else {
            this.startScrollEvent();
        }
    }

    pauseScrollEvent() {
        this.pausescroll = true
    }

    startScrollEvent() {
        this.pausescroll = false
    }

    routerOutlet(o) {
        if (this.screenWidth > 1024) {
            return o.isActivated ? o.activatedRoute : '';
        }
    }

    removeNoResult() {
        this.pageService.removeSearchHeader();
        this.searchService.filter("");
        this.pageService.goToTop();
        this.noResults = false;
    }
}
